export const getFilteredList = (searchWord, bankName, data) => {
    const searchWordLower = searchWord ? searchWord.toLowerCase() : null

    return data.filter(center => {

        const addCenter = getCenterFromSplitedString(searchWordLower, center, bankName)
        if (addCenter) {
            return center
        }
    })
}

const getCenterFromSplitedString = (searchWord, center, bankName) => {
    if (!searchWord) {
        return bankName?.toLowerCase() === center.bankName?.toLowerCase()
    }

    // Split the searchWord into parts (numbers and words)
    const parts = searchWord.match(/\d+|[^\d\s,]+(?:\s[^\d\s,]+)*/g)
    if (!parts) return false

    const zipCodeLower = center.zipcode ? center.zipcode.toLowerCase() : null
    const cityLower = center.city ? center.city.toLowerCase() : null
    const addressLower = center.address ? center.address.toLowerCase() : null

    // Ensure all parts of the searchWord are matched
    const allPartsMatch = parts.every(part => {
        return (
            zipCodeLower?.includes(part.toLowerCase()) ||
            cityLower?.includes(part.toLowerCase()) ||
            addressLower?.includes(part.toLowerCase())
        )
    })

    if (allPartsMatch) {
        if (!bankName) {
            return true
        } else if (bankName?.toLowerCase() === center.bankName?.toLowerCase()) {
            return true
        }
    }

    return false
}

export const getMaxLocationsShownLength = (searchWord, bankName, data) => {
    const filteredList = getFilteredList(searchWord, bankName, data)
    return filteredList.length > 0 ? filteredList.length : 0
}

export const checkIfNoDirectResults = (searchWord, bankName, data) => {
    if (!searchWord && !bankName) {
        return false
    }

    const filteredList = getFilteredList(searchWord, bankName, data)
    return filteredList.length === 0
}


